export default __webpack_public_path__ + "static/media/button.ae9f2d4a.mp3";